var jsonData = {
    'list': [

        {
            title: '1西安市蓝田县九间房镇峪口村', //标题
            cover: 'http://cdn.zjhzart.cn/cloud/www.zjhzart.cn/2023-06-07/1686130231924_MNQ5kaa2.jpg', // 封面图   
            url: 'https://cdn.zjhzart.cn/cloud/www.zjhzart.cn/2023/06/1685602259000_nT5mkK.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '这是简介KADA这是第二段', //简介，需要换行的用"KADA" 分割
            time: '2023-07-01', //日期
            class: 1,  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '文化馆',//报送单位
            standby1: '',//备用1 
        },
        {
            title: '2西安市蓝田县九间房镇峪口村', //标题
            cover: 'https://cdn.zjhzart.cn/cloud/www.zjhzart.cn/2023/06/1686733410000_5ewCN2.png', // 封面图   
            url: 'http://play.kadadx.com/live/170434.m3u8?txSecret=ff02cb3eb8e325e135f0557931418080&txTime=648FEC96',   // 视频链接
            type: 0,    //0,直播 1，回放，2，外链
            brief: '这是简介KADA这是第二段', //简介，需要换行的用"KADA" 分割
            time: '2023-07-04', //日期
            class: 1,  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '文化馆',//报送单位
            standby1: '',//备用1 
        },
        {
            title: '5西安市蓝田县九间房镇峪口村', //标题
            cover: 'http://cdn.zjhzart.cn/cloud/www.zjhzart.cn/2023-06-13/1686639325556_DYWpsGGz.jpg', // 封面图   
            url: 'https://cdn.zjhzart.cn/cloud/www.zjhzart.cn/2023/06/1685602259000_nT5mkK.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '这是简介KADA这是第二段', //简介，需要换行的用"KADA" 分割
            time: '2023-07-18', //日期
            class: 3,  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '文化馆',//报送单位
            standby1: '',//备用1 
        },

        {
            title: '3西安市蓝田县九间房镇峪口村', //标题
            cover: 'http://cdn.zjhzart.cn/cloud/www.zjhzart.cn/2023-06-07/1686130232152_5Q62SpYs.jpg', // 封面图   
            url: 'https://cdn.zjhzart.cn/cloud/www.zjhzart.cn/2023/06/1685602259000_nT5mkK.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '这是简介KADA这是第二段', //简介，需要换行的用"KADA" 分割
            time: '2023-07-05', //日期
            class: 2,  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '文化馆',//报送单位
            standby1: '',//备用1 
        },
        {
            title: '4西安市蓝田县九间房镇峪口村', //标题
            cover: 'https://cdn.zjhzart.cn/cloud/www.zjhzart.cn/2023/05/1685430764000_2czAjF.jpg', // 封面图   
            url: 'https://cdn.zjhzart.cn/cloud/www.zjhzart.cn/2023/06/1685602259000_nT5mkK.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '这是简介KADA这是第二段', //简介，需要换行的用"KADA" 分割
            time: '2023-07-18', //日期
            class: 2,  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '文化馆',//报送单位
            standby1: '',//备用1 
        },
        {
            title: '4西安市蓝田县九间房镇峪口村', //标题
            cover: 'https://cdn.zjhzart.cn/cloud/www.zjhzart.cn/2023/05/1685430764000_2czAjF.jpg', // 封面图   
            url: 'https://cdn.zjhzart.cn/cloud/www.zjhzart.cn/2023/06/1685602259000_nT5mkK.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '这是简介KADA这是第二段', //简介，需要换行的用"KADA" 分割
            time: '2023-07-18', //日期
            class: 1,  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '文化馆',//报送单位
            standby1: '',//备用1 
        },
        {
            title: '4西安市蓝田县九间房镇峪口村', //标题
            cover: 'https://cdn.zjhzart.cn/cloud/www.zjhzart.cn/2023/05/1685430764000_2czAjF.jpg', // 封面图   
            url: 'https://cdn.zjhzart.cn/cloud/www.zjhzart.cn/2023/06/1685602259000_nT5mkK.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '这是简介KADA这是第二段', //简介，需要换行的用"KADA" 分割
            time: '2023-07-18', //日期
            class: 1,  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '文化馆',//报送单位
            standby1: '',//备用1 
        },
        {
            title: '6西安市蓝田县九间房镇峪口村', //标题
            cover: 'https://cdn.zjhzart.cn/cloud/www.zjhzart.cn/2023/06/1685667575000_YBJTrj.jpg', // 封面图   
            url: 'https://cdn.zjhzart.cn/cloud/www.zjhzart.cn/2023/06/1685602259000_nT5mkK.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '这是简介KADA这是第二段', //简介，需要换行的用"KADA" 分割
            time: '2023-08-05', //日期
            class: 4,  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '文化馆',//报送单位
            standby1: '',//备用1 
        },
        {
            title: '7西安市蓝田县九间房镇峪口村', //标题
            cover: 'https://cdn.zjhzart.cn/cloud/www.zjhzart.cn/2023/06/1685667575000_YBJTrj.jpg', // 封面图   
            url: 'https://cdn.zjhzart.cn/cloud/www.zjhzart.cn/2023/06/1685602259000_nT5mkK.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '这是简介KADA这是第二段', //简介，需要换行的用"KADA" 分割
            time: '2023-08-05', //日期
            class: 5,  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '文化馆',//报送单位
            standby1: '',//备用1 
        },
        {
            title: '8西安市蓝田县九间房镇峪口村', //标题
            cover: 'https://cdn.zjhzart.cn/cloud/www.zjhzart.cn/2023/06/1685667575000_YBJTrj.jpg', // 封面图   
            url: 'https://cdn.zjhzart.cn/cloud/www.zjhzart.cn/2023/06/1685602259000_nT5mkK.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '这是简介KADA这是第二段', //简介，需要换行的用"KADA" 分割
            time: '2023-08-05', //日期
            class: 5,  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '文化馆',//报送单位
            standby1: '',//备用1 
        },
        {
            title: '9西安市蓝田县九间房镇峪口村', //标题
            cover: 'https://cdn.zjhzart.cn/cloud/www.zjhzart.cn/2023/06/1685667575000_YBJTrj.jpg', // 封面图   
            url: 'https://cdn.zjhzart.cn/cloud/www.zjhzart.cn/2023/06/1685602259000_nT5mkK.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '这是简介KADA这是第二段', //简介，需要换行的用"KADA" 分割
            time: '2024-07-07', //日期
            class: 5,  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '文化馆',//报送单位
            standby1: '',//备用1 
        },
        {
            title: '10西安市蓝田县九间房镇峪口村', //标题
            cover: 'https://cdn.zjhzart.cn/cloud/www.zjhzart.cn/2023/06/1685667575000_YBJTrj.jpg', // 封面图   
            url: 'https://cdn.zjhzart.cn/cloud/www.zjhzart.cn/2023/06/1685602259000_nT5mkK.mp4',   // 视频链接
            type: 1,    //0,直播 1，回放，2，外链
            brief: '这是简介KADA这是第二段', //简介，需要换行的用"KADA" 分割
            time: '2024-07-08', //日期
            class: 5,  // 1---春季，2---夏季，3---秋季，4---冬季,5---地方风采
            unit: '文化馆',//报送单位
            standby1: '',//备用1 
        },
    ]
}
export default jsonData


// WEBPACK FOOTER //
// ./src/api/datalist.js